import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc035344&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bc035344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc035344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc035344')) {
      api.createRecord('bc035344', component.options)
    } else {
      api.reload('bc035344', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc035344&scoped=true&", function () {
      api.rerender('bc035344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/view-report/index.vue"
export default component.exports